import React from 'react';
import DataTable from 'react-data-table-component';

const TableComponent = (props) => {
  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: 'ALL',
  };

  return (
    <div>
      <DataTable
        title={props.title}
        columns={props.columns}
        data={props.data}
        // defaultSortFieldId='phone'
        highlightOnHover
        striped={true}
        pagination
        paginationComponentOptions={paginationComponentOptions}
        paginationRowsPerPageOptions={[10, 25, 50]}
        // paginationComponentOptions={{
        //   noRowsPerPage: true,
        // }}
        actions={props.actions}></DataTable>
    </div>
  );
};

export default TableComponent;
